import { Component, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subject, Subscription } from 'rxjs';
import { GasThree } from '../../../models/gasthree.model';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { fadeInOut } from '../../../services/animations';
import { GasThreeService } from '../../../services/gasthree.service';


@Component({
    selector: 'gasthree-overview',
    template: require('./gasthree-overview.component.html'),
    styles: [require('./gasthree-overview.component.css')],
    animations: [fadeInOut]
})
export class GasThreeOverviewComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];

    loading: boolean;
    pagingData: GasThree[] = [];
    currentPage = 1;
    pageSize = 20;
    search = '';
    totalRecords = 0;
    orderByField = 'Date';
    isDesc = false;
    modelChanged = new Subject<string>();

    constructor(private accountService: AccountService, private gasthreeService: GasThreeService, private alertService: AlertService, private ngxLogger: NGXLogger) { }

    ngOnInit() {
        const modelSub = this.modelChanged.debounceTime(500)
            .subscribe(() => {
                this.initializeDataListByPage(1);
            });
        this.subscribers.push(modelSub);
        this.initializeDataListByPage(1);
    }

    initializeDataListByPage(page: number) {
        this.loading = true;
        this.currentPage = page;
        const dataListByPageSub = this.gasthreeService.getDataListByPage(page, this.pageSize, this.orderByField, this.isDesc, this.search)
            .subscribe((data: any) => {
                if (data && data.Item1) {
                    this.pagingData = data.Item1;
                    this.totalRecords = data.Item2;
                } else {
                    this.pagingData = [];
                    this.totalRecords = 0;
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.error(err);
                this.ngxLogger.error(err.message);
            });
        this.subscribers.push(dataListByPageSub);
    }

    globalSearch() {
        this.modelChanged.next();
    }

    paginate(event: any) {
        this.pageSize = event.rows;
        this.initializeDataListByPage(event.page + 1);
    }

    customSort(event: any) {
        let isDesc: boolean;
        if (event.order === -1) {
            isDesc = true;
        } else {
            isDesc = false;
        }
        if (event.field !== this.orderByField || isDesc !== this.isDesc) {
            this.orderByField = event.field;
            this.isDesc = isDesc;
            this.initializeDataListByPage(this.currentPage);
        }
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    get cangasthreeOverviewPermission() {
        return this.accountService.userHasPermission(Permission.GasThreeOverviewPermission);
    }

    get cangasthreeExportPermission() {
        return this.accountService.userHasPermission(Permission.GasThreeExportPermission);
    }

    get canaddGasThree() {
        return this.accountService.userHasPermission(Permission.addGasThreePermission);
    }

    get caneditGasThree() {
        return this.accountService.userHasPermission(Permission.editGasThreePermission);
    }

    get candeleteGasThree() {
        return this.accountService.userHasPermission(Permission.deleteGasThreePermission);
    }

    deleteGasthree(gasthree: GasThree) {
        this.alertService.showDialog('Weet je zeker dat je ' + gasthree.StripName + ' wilt verwijderen ?', DialogType.confirm, () => {
            const deleteGasthreeSubscriber = this.gasthreeService.delete(gasthree.Id).subscribe(res => {
                this.alertService.showMessage('Klant', 'Met succes verwijderd!', MessageSeverity.success);
                this.ngOnInit();
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(deleteGasthreeSubscriber);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/gas-three/gasthree-overview/gasthree-overview.component.ts